import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
import moment from "moment";

class SelectDropdownFilter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			listOpen: false,
			headerTitle: this.props.title,
		};
	}

	componentDidUpdate() {
		const { listOpen } = this.state;
		setTimeout(() => {
			if (listOpen) {
				document.addEventListener("click", this.close);
			} else {
				document.removeEventListener("click", this.close);
			}
		}, 0);
	}

	componentWillUnmount() {
		window.removeEventListener("click", this.close);
	}

	close = (e) => {
		if (this.dropdownElements.contains(e.target)) {
			return;
		}
		this.setState({
			listOpen: false,
		});
	};

	toggleList() {
		this.setState((prevState) => ({
			listOpen: !prevState.listOpen,
		}));
	}

	renderDropdownElements = () => {
		// const {auditLog = []} = this.props;
		return (
			<div>
				<CheckBoxContainer
					showSelectAll={false}
					toggleSelection={this.props.toggleElementSelection}
					checkboxItemsList={this.props.checkboxItemsList}
				/>
			</div>
		);
	};

	render() {
		const { listOpen } = this.state;
		return (
			<div ref={(elem) => (this.dropdownElements = elem)}>
				<Button className="inline-button" className="inline-button" onClick={() => this.toggleList()}>
					<span style={{marginRight:"10px"}}>{this.props.label}</span>
					{this.props.count ? (
						<span>{this.props.count}</span>
					) : (
						<span>0</span>
					)}
				</Button>
				{listOpen && (
					<div className="dd-list selectServiceType">
						<div>{this.renderDropdownElements()}</div>
					</div>
				)}
			</div>
		);
	}
}

export default SelectDropdownFilter;
